import { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

import {
  getSettings,
  updateSettings,
} from "../../../../../../../services/settingsServices";

import {
  DEFAULT_INFOCLUB_SETTINGS,
  buildInfoClubPreviewSettings,
  calculateInfoClubStats,
  normalizeInfoClubPayload,
  unwrapSettings,
  validateInfoClubSettings,
} from "../utils/infoClubSettingsUtils";

export function useInfoClubSettings() {
  const [settings, setSettings] = useState(DEFAULT_INFOCLUB_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [previewDark, setPreviewDark] = useState(false);

  const fetchSettings = useCallback(async () => {
    try {
      setLoading(true);

      const data = await getSettings();
      const first = unwrapSettings(data);

      if (first) {
        setSettings({
          ...DEFAULT_INFOCLUB_SETTINGS,
          ...first,
          infoclub_isactive:
            first?.infoclub_isactive === undefined ||
            first?.infoclub_isactive === null
              ? true
              : !!first.infoclub_isactive,
        });
      }
    } catch (error) {
      console.error("Erreur chargement Info Club :", error);
      toast.error("Impossible de charger les paramètres Info Club.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const stats = useMemo(() => {
    return calculateInfoClubStats(settings);
  }, [settings]);

  const previewSettings = useMemo(() => {
    return buildInfoClubPreviewSettings(settings);
  }, [settings]);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    setSettings((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleContentChange = (name, value) => {
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const toggleActive = () => {
    setSettings((prev) => ({
      ...prev,
      infoclub_isactive: !prev.infoclub_isactive,
    }));
  };

  const saveSettings = async (event) => {
    event?.preventDefault?.();

    const payload = normalizeInfoClubPayload(settings);
    const errorMessage = validateInfoClubSettings(payload);

    if (errorMessage) {
      toast.error(errorMessage);
      return;
    }

    try {
      setSaving(true);

      await updateSettings(payload);

      setSettings(payload);
      toast.success("Informations du club mises à jour avec succès.");
    } catch (error) {
      console.error("Erreur sauvegarde Info Club :", error);
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data ||
          "Erreur lors de la mise à jour des informations du club."
      );
    } finally {
      setSaving(false);
    }
  };

  return {
    settings,
    loading,
    saving,

    stats,
    previewSettings,

    previewDark,
    setPreviewDark,

    handleChange,
    handleContentChange,
    toggleActive,
    saveSettings,
    fetchSettings,
  };
}